// extracted by mini-css-extract-plugin
export default {"pageTitle":"create-ticket-page_pageTitle__zCOko","recentTickets":"create-ticket-page_recentTickets__PwIqe"};